import { Button, Loading, NewsList } from '@/components'
import { Layout } from '@/components'
import CampaignComponents from '@/components/CampaignComponents'
import Dialog from '@/components/Dialog/Dialog'
import { DialogPopup } from '@/components/Dialog/DialogPopup'
// import { NotifyPreferredBrowser } from '@/components/molecules/NotifyPreferredBrowser'
import { StampSheet, StampSheetArrow } from '@/components/molecules'
import { dialogGroupSpotsState, groupSpotsState } from '@/features/dialogGroupSpotsSlice'
import { dialogStatePoint } from '@/features/dialogSlice'
import { raundUrl } from '@/lib/custom'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { usePaakAd } from '@/lib/usePaakAd'
// import { usePreferredBrowser } from '@/lib/usePreferredBrowser'
import { useTracking } from '@/lib/useTracking'
import { time } from '@/lib/util'
import { homeStateMachine } from '@/stateMachine/homeStateMachine'
import type { RootState } from '@/store/store'
import styles from '@/styles/Home.module.scss'
import { useMachine } from '@xstate/react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useState, useRef, useEffect, Fragment, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
// @ts-ignore
import type { SwiperOptions } from 'swiper/types'
import useSWR from 'swr'
export { getStaticPaths, getStaticProps } from '@/lib/getStaticFunctions'
import { useFetchGet } from '@/lib/useFetch'
import { useLocalStorageClear } from '@/lib/useLocalStorageClear'

//import { createBrowserInspector } from '@statelyai/inspect'
//const { inspect } = createBrowserInspector()

// const getBrowser = (): Browser.BrowserType => {
//   const ua = navigator.userAgent
//   if (/Safari/.test(ua) && !/Chrome/.test(ua)) return 'safari'
//   if (/Chrome|Chromium/.test(ua)) return 'chrome'
//   return 'other'
// }

const Home = () => {
  const { t, i18n } = useTranslation()
  const swiperRef = useRef(null)
  const dispatch = useDispatch()
  const router = useRouter()
  // const { options } = usePreferredBrowser()
  const { gen, LOCAL_STORAGE_SPOT_SELECTION_KEY } = useCampaignSlug()
  const clear = useLocalStorageClear()
  useTracking({ page: 'home' })

  const [stateMachine, send] = useMachine(homeStateMachine)
  const [isAvailable, setAvailable] = useState<boolean>(true)
  const [isSwiperBeginning, setIsSwiperBeginning] = useState(true)
  const [isSwiperEnd, setIsSwiperEnd] = useState(false)
  const [stampSheetImageSize, setStampSheetImageSize] = useState<{ width: number; height: number; index: number }[]>([
    { width: 0, height: 0, index: -1 },
  ])

  const [dialogContentState, setDialogContentState] = useState<Api.UserSheetObject>()
  const [swiperIndex, setSwiperIndex] = useState(1)

  const dialogPointSelector = useSelector((state: RootState) => state.dialog.dialogStatePoint)
  const dialogGroupSpotsSelector = useSelector((state: RootState) => state.dialogGroupSpots.boolean)
  const groupSpotsSelector = useSelector((state: RootState) => state.dialogGroupSpots.spots)
  const { getWithAuth: getSheets } = useFetchGet<Api.SheetsResBody>({})
  const { getWithAuth: getUser } = useFetchGet<Api.UserResBody>({})
  const { getWithAuth: getNotifications } = useFetchGet<Api.NotificationsResBody>({})
  const { getWithAuth: getUserSheets } = useFetchGet<Api.UserSheetsResBody>({})
  const { getWithoutAuth: campaignGet } = useFetchGet<{ campaign: Api.CampaignResBody }>({})
  const { data: campaignData } = useSWR<{ campaign: Api.CampaignResBody }>(raundUrl.campaign, campaignGet)

  const { data: userState, error: userFetchError } = useSWR<Api.UserResBody>(raundUrl.user, getUser, {
    revalidateOnFocus: false,
  })

  const { data: FetchSheetsState, error: userSheetsFetchError } = useSWR<Api.UserSheetsResBody>(
    raundUrl.userSheets,
    getUserSheets,
    {
      revalidateOnFocus: false,
    },
  )

  const { data: notificationData, error: notificationFetchError } = useSWR<Api.NotificationsResBody>(
    raundUrl.notifications,
    getNotifications,
    {
      revalidateOnFocus: false,
    },
  )

  const { data: SpotsSheetsState, error: sheetsFetchError } = useSWR<Api.SheetsResBody>(raundUrl.sheets, getSheets, {
    revalidateOnFocus: false,
  })
  const goPrev = () => {
    swiperRef.current?.swiper?.slidePrev()
  }

  const goNext = () => {
    swiperRef.current?.swiper?.slideNext()
  }

  const params: SwiperOptions = useMemo(
    () => ({
      speed: 1000,
      centeredSlides: true,
      roundLengths: true,
      spaceBetween: 30,
      autoHeight: campaignData?.campaign.sheetMode !== 'OVERLAY',
      slidesPerView: 1,
      pagination: {
        el: '#pagination',
        type: 'bullets',
        clickable: true,
      },
      onSlideChange: (swiper) => {
        setSwiperIndex(swiper.realIndex + 1)
        setIsSwiperBeginning(swiper.isBeginning)
        setIsSwiperEnd(swiper.isEnd)
      },
      on: {
        slideChange: (swiper) => {
          setSwiperIndex(swiper.realIndex + 1)
          setIsSwiperBeginning(swiper.isBeginning)
          setIsSwiperEnd(swiper.isEnd)
        },
        onSwiper: (swiper) => {
          swiperRef.current = swiper
        },
      },
    }),
    [],
  )
  // 画像を重ねるOVERLAYの場合のみ、swiperのスタイルを指定する
  const style = useMemo(() => {
    if (campaignData?.campaign.sheetMode === 'OVERLAY') {
      return stampSheetImageSize.find((item) => item.index === swiperIndex - 1)
    } else {
      return {}
    }
  }, [swiperIndex, stampSheetImageSize])

  const popupAcquisitionStatus = useCallback(
    (content: Api.UserSheetObject) => {
      dispatch(dialogStatePoint(true))
      setDialogContentState(content)
    },
    [dispatch],
  )

  useEffect(() => {
    if (FetchSheetsState !== undefined && notificationData !== undefined) {
      setAvailable(false)
      return
    }
  }, [FetchSheetsState, notificationData])

  useEffect(() => {
    // 期間外に関する状態保持
    if (campaignData?.campaign && !!campaignData?.campaign.type) {
      send({
        type: 'onInitialCampaignLoad',
        campaign: {
          type: campaignData?.campaign.type,
          period: campaignData?.campaign.period,
          campaignStartAt: campaignData?.campaign.campaignStartAt,
          campaignEndAt: campaignData?.campaign.campaignEndAt,
          isRepeatStamp: campaignData?.campaign.isRepeatStamp,
        },
      })
      send({ type: 'onInitialCompleteLoad' })
      send({ type: 'onCheckCampaignIsOpen' })
    }
  }, [campaignData?.campaign])

  const showCouponList = useCallback(() => {
    localStorage.setItem(LOCAL_STORAGE_SPOT_SELECTION_KEY, 'coupon')
    router.push({
      pathname: gen('/spot/'),
    })
  }, [dispatch, router])

  // 広告効果計測
  usePaakAd({ campaign: campaignData?.campaign, requestWithUserId: true, userId: userState?.user.id })
  // ユーザーの強制パスワード変更
  useEffect(() => {
    if (userState) {
      if (userState.user.changePassword) {
        router.push({
          pathname: gen('/auth/changeForcePassword'),
        })
      }
      if (!userState.user.login && campaignData?.campaign.custom === 'NTT') {
        clear()
        location.href = gen('/auth/signin')
      }
    }
  }, [userState])

  if (isAvailable) return <Loading />
  if (userSheetsFetchError) return <div>{''}</div>
  if (notificationFetchError) return <div>{''}</div>
  if (sheetsFetchError) return <div>{''}</div>

  return (
    <Layout title={t('common.title')}>
      <CampaignComponents campaign={campaignData?.campaign} />
      {notificationData?.notifications && notificationData.notifications.length !== 0 ? (
        <section className="c-shadow_top bg-white mt-8 pt-6 pb-10">
          <div className="l-inner">
            <h2 className="text-center text-h2 font-bold">{t('home.notification', 'お知らせ')}</h2>
            <div className="my-8">
              {notificationData?.notifications[0] &&
                notificationData.notifications.slice(0, 3).map((content) => {
                  return (
                    <Fragment key={`fr-${content.id}`}>
                      <NewsList
                        link={gen('/news/detail/')}
                        time={time({
                          time: content.startAt,
                          language: i18n.language,
                        })}
                        text={content.title}
                        query={`${content.id}`}
                      />
                    </Fragment>
                  )
                })}
            </div>
            <Button
              text={t('home.notification_list', 'お知らせ一覧へ')}
              width="w-9/12"
              bgColor="bg-[#fff]"
              onClick={() => {
                router.push(gen('/news/'))
              }}
            />
          </div>
        </section>
      ) : (
        ''
      )}
      <section className="my-8">
        <div className="l-inner">
          {/* ポイントラリーでコース数が1つの場合は総獲得ポイントを表示しない */}
          {campaignData?.campaign.type === 3 ||
          (campaignData?.campaign.type === 2 && FetchSheetsState.sheets.length <= 2) ? (
            ''
          ) : (
            <>
              <h2 className="text-center text-h2 font-bold">
                {campaignData?.campaign.type === 1 && t('home.collected_stamps', '獲得スタンプ')}
                {campaignData?.campaign.type === 2 && t('home.total_points', '総獲得ポイント')}
              </h2>

              {campaignData?.campaign.type === 2 && FetchSheetsState.sheets && (
                <div className="c-shadow mt-3 rounded-[4px] bg-[#fff] p-[10px] text-center">
                  <p className="text-[80px] font-bold">
                    {FetchSheetsState.sheets[0].earnedPoints}
                    <span className="text-[30px] font-bold">pt</span>
                  </p>
                </div>
              )}
            </>
          )}

          {/* type === 1: スタンプ, type === 2: ポイント, type === 3: ポイント減算 */}
          {campaignData?.campaign.type === 1 && (
            <div className={`c-topSwiper relative mt-[18px]`}>
              <div id="pagination" className="flex justify-center space-x-1.75 mb-[10px]" />
              <p className="c-topSwiper_fraction">
                {swiperIndex} / {FetchSheetsState.sheets?.slice(1).length}
              </p>
              <StampSheetArrow onClick={goPrev} position={'left'} hide={isSwiperBeginning} />
              <StampSheetArrow
                onClick={goNext}
                position={'right'}
                hide={isSwiperEnd || FetchSheetsState.sheets?.slice(1).length === 1}
              />
              <Swiper modules={[Pagination]} {...params} ref={swiperRef} style={style}>
                {FetchSheetsState.sheets?.slice(1).map((content, idx) => {
                  return (
                    <SwiperSlide key={`slide-${content.id}-${idx}`}>
                      <StampSheet
                        idx={idx}
                        sheet={content}
                        campaign={{
                          isRepeatStamp: campaignData?.campaign.isRepeatStamp,
                          stampShape: campaignData?.campaign.stampShape,
                          sheetMode: campaignData?.campaign.sheetMode,
                        }}
                        onStampClick={(spots) => {
                          dispatch(dialogGroupSpotsState(true))
                          dispatch(groupSpotsState(spots))
                        }}
                        setStampSheetImageSize={setStampSheetImageSize}
                      />
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          )}

          {campaignData?.campaign.type === 2 && (
            <div className="c-topSwiper relative mt-[25px]">
              <div id="pagination" className="flex justify-center space-x-1.75 mb-[10px]" />
              <p className="c-topSwiper_fraction">
                {swiperIndex} / {FetchSheetsState.sheets?.slice(1).length}
              </p>

              <StampSheetArrow onClick={goPrev} position={'left'} hide={isSwiperBeginning} />
              <StampSheetArrow
                onClick={goNext}
                position={'right'}
                hide={isSwiperEnd || FetchSheetsState.sheets?.slice(1).length === 1}
              />
              <Swiper modules={[Pagination]} {...params} ref={swiperRef}>
                {FetchSheetsState.sheets?.slice(1).map((content) => {
                  return (
                    <SwiperSlide key={`slide-${content.id}`}>
                      <div key={`div-${content.id}`} className={`mt-[40px] ${styles.c_stamp_body}`}>
                        <div className="relative">
                          <h2 className="px-3 text-center text-sm font-bold">{content.name}</h2>
                        </div>
                        <div className="mx-3 mt-5 text-center">
                          <p className="text-[14px]">{t('home.total_point_in_course', 'コース累計獲得ポイント')}</p>
                          <p className="text-[48px] font-bold">
                            {content.earnedPoints}
                            <span className="text-[24px] font-bold">pt</span>
                          </p>
                        </div>
                        <p
                          className={styles.c_acquisitionStatus}
                          onClick={() => popupAcquisitionStatus(content)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              popupAcquisitionStatus(content)
                            }
                          }}
                        >
                          {t('home.collected_status_in_each_spot', 'スポットごとの獲得状況')}
                        </p>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          )}

          {campaignData?.campaign.type === 3 && (
            <div className="c-topSwiper relative mt-[25px]">
              <div id="pagination" className="flex justify-center space-x-1.75 mb-[10px]" />
              <p className="c-topSwiper_fraction">
                {swiperIndex} / {FetchSheetsState.sheets?.slice(1).length}
              </p>
              <StampSheetArrow onClick={goPrev} position={'left'} hide={isSwiperBeginning} />
              <StampSheetArrow
                onClick={goNext}
                position={'right'}
                hide={isSwiperEnd || FetchSheetsState.sheets?.slice(1).length === 1}
              />
              <Swiper modules={[Pagination]} {...params} ref={swiperRef}>
                {FetchSheetsState.sheets?.slice(1).map((content) => {
                  return (
                    <SwiperSlide key={`slide-${content.id}`}>
                      <div key={`div-${content.id}`} className={`mt-[40px] ${styles.c_stamp_body}`}>
                        <div className="relative">
                          <h2 className="px-3 text-center text-sm font-bold">{content.name}</h2>
                        </div>
                        <div className="mx-3 mt-5 text-center">
                          <p className="text-[14px]">{t('home.remaining_point_in_course', 'コース別残ポイント')}</p>
                          <p className="text-[48px] font-bold">
                            {content.earnedPoints}
                            <span className="text-[24px] font-bold">pt</span>
                          </p>
                        </div>
                        <p
                          className={styles.c_acquisitionStatus}
                          onClick={() => router.push(gen('/pointHistory'))}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              router.push(gen('/pointHistory'))
                            }
                          }}
                        >
                          {t('home.point_history', 'ポイント履歴')}
                        </p>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          )}
        </div>
      </section>
      {SpotsSheetsState?.sheets?.some((sheet) => sheet.id === 'coupon' && sheet.spots) && (
        <Button
          text={t('home.coupon_list', 'クーポン一覧へ')}
          width="w-9/12"
          borderColor="border-[#ff9bcd]"
          bgColor="bg-[#ff9bcd]"
          classes="mb-8"
          onClick={() => showCouponList()}
        />
      )}
      {campaignData?.campaign.custom === 'NEXTTUBE' && (
        <div className={'mt-6'}>
          <Button
            text={t('common.form', 'お問い合わせ')}
            width="w-9/12"
            bgColor="bg-[#fff]"
            onClick={() => {
              router.replace({ pathname: gen('/ocrForm') })
            }}
          />
        </div>
      )}
      <Dialog
        title={t('home.collected_status_in_each_spot', 'スポットごとの獲得状況')}
        selectorState={dialogPointSelector}
        dispatchAction={dialogStatePoint}
      >
        <ul className="mt-[25px]">
          {dialogContentState?.stamps?.map((stamp) => {
            return (
              <li key={`spot-${stamp.spotId}`} className="c_pointTableList">
                <table className="c_pointTable">
                  <tr>
                    <th>
                      <Link
                        href={{
                          pathname: gen('/spot/detail/'),
                          query: {
                            query: stamp.spotId,
                          },
                        }}
                      >
                        <button
                          type="button"
                          className="text-[13px] font-semibold underline"
                          onClick={() => {
                            dispatch(dialogStatePoint(false))
                          }}
                        >
                          {stamp.name}
                        </button>
                      </Link>
                    </th>
                    <td className="text-[20px] font-bold">
                      {stamp.earnedPoints}
                      <span className="text-[16px]">pt</span>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-[11px] font-light">
                      {t('home.point_where_you_get_stamp', 'このスポットで獲得できるポイント')}
                    </th>
                    <td className="text-[16px] font-light">
                      {stamp.point}
                      <span className="text-[12px]">pt</span>
                    </td>
                  </tr>
                </table>
              </li>
            )
          })}
        </ul>
      </Dialog>
      {/* スポットグループモーダル */}
      <Dialog
        title={t('home.spot_where_you_get_stamp', 'このスタンプを獲得できるスポット')}
        titleSmall
        selectorState={dialogGroupSpotsSelector}
        dispatchAction={dialogGroupSpotsState}
      >
        <ul className="mt-[25px]">
          {groupSpotsSelector?.map((spot) => {
            return (
              <li key={`spot-li-${spot.id}`} className="c_pointTableList">
                <table className="c_pointTable">
                  <tr>
                    <th className="py-[7.25px]">
                      <Link
                        href={{
                          pathname: gen('/spot/detail/'),
                          query: {
                            query: spot.id,
                          },
                        }}
                      >
                        <button
                          type="button"
                          className="text-[13px] font-semibold underline"
                          onClick={() => {
                            dispatch(dialogGroupSpotsState(false))
                          }}
                        >
                          {spot.name}
                        </button>
                      </Link>
                    </th>
                  </tr>
                  <tr>
                    <th className="py-[3.75px] text-[11px] font-light">{spot.address}</th>
                  </tr>
                </table>
              </li>
            )
          })}
        </ul>
      </Dialog>
      <DialogPopup hookpoint="HOME" campaign={campaignData?.campaign} />
    </Layout>
  )
}

export default Home
